class Controller {
  constructor($injector) {
    "ngInject";
    this.City = $injector.get("City");
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.CityTransforms = $injector.get("CityTransforms");
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.isShowTripCategoriesEditable = false;
    this.onUpdateTravelSuggestionsFlag = this.Events.getUpdateEvent(
      "onUpdateTravelSuggestionsFeatureFlag"
    );
  }
  $onInit() {
    const updateTravelSuggestionsFlag = () => {
      this.City.patchAction(
        this.cityId,
        "feature_flags/update_travel_suggestions",
        {
          enabled: this.travelSuggestionsFlag.value,
        }
      ).$promise.then(
        (response) => {
          this.travelSuggestionsFlag.isDisabled = true;
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage(
              "city",
              `Show travel suggestion feature ${
                this.travelSuggestionsFlag.value ? "enabled" : "disabled"
              }`
            )
          );
          this.city = this.CityTransforms.justify(response);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
    this.Events.on(
      this.onUpdateTravelSuggestionsFlag,
      updateTravelSuggestionsFlag
    );
  }
  updateShowTripCategoriesFlag() {
    const params = {
      enabled: this.categoriesFlag.enabled,
      options: {
        air_conditioning_tag_enabled: this.categoriesFlag.options
          .air_conditioning_tag_enabled,
        vehicle_type_tag_enabled: this.categoriesFlag.options
          .vehicle_type_tag_enabled,
        service_type_enabled: this.categoriesFlag.options.service_type_enabled,
      },
    };
    this.City.patchAction(
      this.cityId,
      "feature_flags/update_show_trip_categories",
      {
        ...params,
      }
    ).$promise.then(
      (response) => {
        this.isShowTripCategoriesEditable = false;
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage(
            "city Show categories feature flags are updated"
          )
        );
        this.city = this.CityTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/cityFeatureFlags/cityFeatureFlags.controller.js